import request from "../../../../Helpers/API";
import { extraerMensajeError } from "../../../../Helpers/ErrorHelper";

// Cliente HTTP de Indicadores de Visitas. request.get (Helpers/API.js) ya agrega
// "Authorization: Bearer <token>" (localStorage) y maneja 401 de forma global (redirige a
// /auth/login), por eso aquí no se repite esa lógica.
export { extraerMensajeError };

export const IndicadoresVisitasCRMService = {
  // GET /ReporteVisitas — arreglo plano semana/vendedor con objetivo mensual, objetivo semanal,
  // visitas realizadas y cumplimiento. "linea" es el filtro "Tipo" del front ("P" = Programadas,
  // "R" = Realizadas); por default el MainScreen manda "P".
  reporteVisitas: (ejercicio, periodo, tipo) =>
    request.get(`IndicadoresVisitas/ReporteVisitas?ejercicio=${ejercicio}&periodo=${periodo}&tipo=${tipo}`),

  // GET /ImprimirExcelReporteVisitas — regresa { documento (base64), filename }, mismo patrón
  // que los demás reportes CRM (ej. ReportesCRM/ImprimirExcelReporteCoberturaCartera). Se manda
  // el mismo "linea" del filtro actual para que el Excel refleje lo que se ve en pantalla.
  imprimirExcel: (ejercicio, periodo, tipo) =>
    request.get(`IndicadoresVisitas/ImprimirExcelReporteVisitas?ejercicio=${ejercicio}&periodo=${periodo}&tipo=${tipo}`),
};
